// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-elder-person label.no-style,
.basicinfo-elder-persons label.no-style {
  padding: 0;
  font-size: 16px;
  position: relative;
}

.elder-persons .button-box p{
  text-transform: capitalize;
}

.tab-container button.large {
    width: 120px;
}
.equal-height .button-box{
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/elderpersons/ElderPersons.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,YAAY;AAChB;AACA;EACE,YAAY;AACd","sourcesContent":[".create-elder-person label.no-style,\r\n.basicinfo-elder-persons label.no-style {\r\n  padding: 0;\r\n  font-size: 16px;\r\n  position: relative;\r\n}\r\n\r\n.elder-persons .button-box p{\r\n  text-transform: capitalize;\r\n}\r\n\r\n.tab-container button.large {\r\n    width: 120px;\r\n}\r\n.equal-height .button-box{\r\n  height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
